import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import { Form, Grid, Header, Button, Icon } from 'semantic-ui-react'
import { FormValidation, FileBase64 } from '../components'
import { fields } from '../../common/lib/redux-fields'
import {feedbacksPdfAttendanceSave} from '../../common/attendances/actions'
import { validateFile, } from '../../common/attendances/validations'

const { Row, Column } = Grid

class AttendanceFeedbacksPdfForm extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.state = {selectedFile: null, fileProcessing: false}
  }

  async submit(e) {
    e.preventDefault()

    this.setState({fileProcessing: true})

    const { fields, submit, attendance, feedbacksPdfAttendanceSave } = this.props

    const inte = setInterval(async () => {
      const { selectedFile } = this.state

      if (selectedFile) {
        clearInterval(inte)

        const values = fields.$values()

        values['file_name'] = selectedFile.name
        values['file_type'] = selectedFile.type
        values['file_size'] = selectedFile.size
        values['file_data'] = selectedFile.base64

        if (attendance && !!attendance._id) {
          values['_id'] = attendance._id
        } else {
          values['_id'] = null
        }

        await submit(values, feedbacksPdfAttendanceSave)
      }
      else {
        console.log("not processed", this.state.fileProcessing)
      }
    }, 100)
  }

  componentWillMount() {
  }

  componentWillUnmount() {
    this.props.fields.$reset()
  }

  uploadHandler = (e) => {
    this.setState({selectedFile:e})
  }

  render() {
    const { fields, attendance, submitting, submitSuccessfull, errors, errorMessage } = this.props
    const { fileProcessing } = this.state

    if (submitSuccessfull && attendance && attendance._id) return <Redirect to={'/attendances/' + attendance._id} />
    if (submitSuccessfull) return <Redirect to='/attendances/' />

    const fieldData = Object.assign({}, fields)
    errors.forEach(error => {
      if (error.detail && error.detail.field && fieldData[error.detail.field]) {
        fieldData[error.detail.field].error = error.message
      }
    })

    return (
      <Form loading={submitting} size="big">
        <Grid>
          <Row>
            <Column>
              <Header as="h2"><Icon name="file" color="grey" /> Nahrát zpětné vazby v PDF</Header>
            </Column>
          </Row>
          {attendance && attendance.pdf && attendance.pdf.length > 0 &&
          <Row>
            <Column>
              <Icon name="exclamation triangle" size="large" color="red" /> POZOR: Stávající PDF bude nahrazeno!
            </Column>
          </Row>
          }
          <FileBase64 accept="application/pdf" onDone={(e)=>this.uploadHandler(e)} />
        </Grid>

        {errorMessage}

        <Grid>
          <Row>
            <Column>
              {attendance && attendance._id &&
                <Link to={"/attendances/" + attendance._id}><Button>Storno</Button></Link>
              }
              <Button type="button" color="red" disabled={fileProcessing} onClick={(e)=>this.submit(e)}> Uložit </Button>
            </Column>
          </Row>
          {fileProcessing &&
          <Row>
            <Column>
              <img src="/images/loader.gif" alt="loading ..."/>
            </Column>
          </Row>}
        </Grid>
      </Form>
    )
  }
}

AttendanceFeedbacksPdfForm.defaultProps = {
  attendance: null,
  submitting: false,
  submitSuccessfull: false,
  errors: [],
  errorMessage: null
}

AttendanceFeedbacksPdfForm.propTypes = {
  fields: React.PropTypes.object.isRequired,
  attendance: React.PropTypes.object,
  selectedFile: React.PropTypes.object,
  submitting: React.PropTypes.bool,
  submitSuccessfull: React.PropTypes.bool,
  errors: React.PropTypes.array,
  errorMessage: React.PropTypes.any
}

AttendanceFeedbacksPdfForm = fields(AttendanceFeedbacksPdfForm, {
  path: 'AttendanceFeedbacksPdfForm',
  fields: [],
  getInitialState: (props) => {
    const { attendance } = props
    if (attendance && attendance._id) return attendance.toJS()
    return { selectedFile: null, fileProcessing: false }
  },
})

AttendanceFeedbacksPdfForm = FormValidation(AttendanceFeedbacksPdfForm, (props) => {
  const { attendance } = props
  let submissionValidation = validateFile
  return { submissionValidation }
})

export default connect((state) => ({
  viewer: state.attendances.viewer,
  attendance: state.attendances.current,
}), { feedbacksPdfAttendanceSave })(AttendanceFeedbacksPdfForm)



// WEBPACK FOOTER //
// ./src/browser/forms/AttendanceFeedbacksPdf.js